'use strict'

const RavenConstructor = require('raven-js/src/raven')
const base = require('./base')

module.exports = ({ global, appName }) =>
  base({
    global,
    appName,
    options: {},
    createClients: () => ({
      Raven: new RavenConstructor(),
      UserRaven: new RavenConstructor(),
      WixDataRaven: new RavenConstructor()
    })
  })



// WEBPACK FOOTER //
// ./logger/logger.js